import React from "react";

import { StyledLink, StyledLinkProps } from "./styles";

interface FancyLinkProps extends StyledLinkProps {
  to: string | { pathname: string; hash: string };
  onClick?: () => void;
}

export const FancyLink: React.FC<FancyLinkProps> = ({
  onClick,
  children,
  ...rest
}) => (
  <StyledLink {...rest}>
    <span onClick={onClick}>{children}</span>
  </StyledLink>
);
